// A linha completa continua compatível com documentos e clientes antigos da API.
// Somente uma numeração final inequívoca é separada para edição.
export function splitCompanyAddress(value) {
  const line = String(value || '').trim();
  const match = /^(.*),\s*(\d+(?:[ .-]+\d+)*)$/.exec(line);
  return match ? { street: match[1].trim(), number: match[2].replace(/\D/g, '') }
    : { street: line, number: '' };
}

export function joinCompanyAddress(street, number) {
  return [String(street || '').trim(), String(number || '').replace(/\D/g, '')].filter(Boolean).join(', ');
}
